<template>
<!-- 实时监测  -->
<div class="fc monitoringbg" style="border-bottom-color: #FFF; border-bottom-width: 1px; border-bottom-style: dashed;">
  <topbar :dataHeader="responseData.topBar"></topbar>
  <topbar-base ></topbar-base>
  <img src="/imgs/complianceLft.png" alt="" class="complianceLft">
  <div class="pr wf hf">
    <transition name="left-side">
      <com-left
        :resData="responseData"
      />
    </transition>
    <com-center
      class="comCenter"
      :resData="responseData"
    />
    <transition name="right-side">
      <com-right :resData="responseData" />
    </transition>
  </div>
  <img src="/imgs/complianceRt.png" alt="" class="complianceRt">
  <!-- <img src="/imgs/complianceBtom.png" alt="" class="complianceBtom"> -->
</div>
</template>

<script>
import screenAdjustMixin from '@/views/mixin/screenAdjustMixin'
import topbar from './topbar'
import comLeft from './left'
import comCenter from './center'
import comRight from './right'
import API from "@/api/sascreen-api.js"
import topbarBase from "../components/topbar-base"

export default {
  name: 'enterprise-security',
  components: {
    topbarBase,
    topbar,
    comLeft,
    comCenter,
    comRight
  },
  mixins: [ screenAdjustMixin ],
  data () {
    return {
      dcName: 'hami-a',
      responseData: {
        topBar: {},
        dcInfo: {},
        // Left
        devCount: {},
        doorStatus: [],
        smokeAlarm: [],
        waterAlarm: [],
        // Center
        centerMonitoring: {},
        // Right
        envTH: {},
        outletTemperature: {},
        inletTemperature: {},
        energyMonitoring: {},
        energyUsage: [],
        pueLine: {},
        pueData: {},
      },
    }
  },
  mounted () {
    this.viewIndex()
    setInterval(() => {
      // API.getMonitordata({module: 'hamiIndex', key:'allUsage'}).then(data => {
      //   this.responseData.allUsage = JSON.parse(data.data.data.allUsage);
      // })
    }, 10000)
  },
  methods: {
    viewIndex () {
      const keys=
        'topBar, dcInfo, devCount, doorStatus, smokeAlarm, waterAlarm, ' +
        'envTH, outletTemperature, inletTemperature, energyMonitoring, energyUsage, pueLine, pueData, ' +
        'centerMonitoring'

      API.getMonitordata({ module: 'monitoring', key: keys, param: this.dcName }).then(data => {
        this.responseData = data.data.data
        console.log('#monitoring#', this.responseData)
      })
    }
  }
}
</script>
<style>
.monitoringbg{
  width: 1920px;
  height: 1080px;
  background: url(/imgs/compliancebg.png) no-repeat;
  position: relative;
}
.side-panel{
  max-width: 460px;
  top: 0;
  min-width: 460px;
}
.side-panel-bg{
  background: rgab(0,0,0,0,0) !important;
}
.complianceLft{
  position: absolute;
  width: 13px;
  height: 1080px;
  left: 0;
}
.complianceRt{
  position: absolute;
  height: 1080px;
  width: 13px;
  right: 0;
}
.complianceBtom{
  position: absolute;
  width: 100%;
  bottom: 0;
}

</style>
